function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.038 5.478C6.594 8.687 8.548 10.885 12 12c3.452-1.115 5.406-3.313 5.962-6.522a1.5 1.5 0 00-1.491-1.728H7.529a1.5 1.5 0 00-1.491 1.728zM3.75.75h16.5M7.529 20.25a1.5 1.5 0 01-1.491-1.727C6.594 15.314 8.548 13.116 12 12c3.452 1.116 5.406 3.314 5.962 6.523a1.5 1.5 0 01-1.491 1.727zm-3.779 3h16.5",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

function SvgHourglass1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor"
  }, props), _ref);
}

export default SvgHourglass1;